/**
 *    @author: Andrew Sheen
 *    @since:  2021-03-12
 *
 */

import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData, OrderOfBC } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { SubmitApplication } from '../_common/submit/SubmitApplication';
import { HttpClient } from '@angular/common/http';
import { ItemList } from '../_common/constant/item-list';
import { Util } from 'src/refresh/service/Util';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { Confirm } from 'src/refresh/service/constant';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/refresh/service/common-service';

@Component({ 
      selector: 'order_summary',
      templateUrl: './order_summary.component.html',
      styleUrls: ['./order_summary.component.less']
})
export class OrderSummaryComponent extends FormBaseComponent implements OnInit {

       private submitApplication:SubmitApplication;

       public  childList: ChildProduct[] = [];
       public  productList;
       public  backCnt:number = 0;
       public  message:string;
       public  isLastPage:boolean;

       public  orderTotal:number = 0;
       public  disabled:boolean = true;
       private url:string;
       private isOnEditOpened:boolean = false;

       @ViewChild(LightBox)  alertBox: LightBox;
 
       constructor( protected router: Router ,
                    public timerService:TimerService,
                    private translate: TranslateService,
                    public data:InputData,
                           httpClient:HttpClient,
                           items:ItemList,
                    private commonService: CommonService ) {

                    super(router,timerService);  

                    let prevPage = !this.data.CESP.chk_consent? Path.ESRAreYouSure
                                                              : Path.ESRMain;
                    if ( data.eligibility.isCustodyOtherThanParent == Confirm.YES ) {
                         if ( data.aboutChild.isChildDeceased == Confirm.YES ) 
                              prevPage = Path.FinalReview
                         else prevPage = Path.BirthCertificate;
                    }         
                    else                                 
                    if ( data.aboutChild.isChildDeceased == Confirm.YES ) 
                              prevPage = Path.CCBMain;

                    super.setNextPage(Path.ProvincialPayment,prevPage);

                    this.submitApplication = new SubmitApplication(httpClient,data,timerService,items);

                    let birthType:number = Number(this.data.eligibility.birthType);

                    this.isLastPage = this.data.subject.index >= birthType; 
                    this.disabled = !!data.subject.siteKey;

                    this.commonService.getCloseLightBox().subscribe((r) =>{
                        if(this.isOnEditOpened) this.onNoteClose();
                    });

                    InputData.currentPageIdx = 23;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       private getPrice(amount:number) {
              if ( "fr" == this.translate.store.currentLang ) 
                    return amount + ' $';
              else  return '$' + amount;
       }

       public ngOnInit() {
 
              super.forwardNext(0);
              
              let count = this.data.subject.index - 1;
              for ( let i = 0; i <= count ; i++ ) {
                    this.addProduct(this.data.subject.inputDataList[i], i==count );  
              }
       }

       //type 0: this.url = Path.BirthCertificate;
       //type 1: this.url = Path.CCBMain; 
       //type 2: this.url = Path.SINMain;
       //type 3: this.url = Path.ESRMain;

       public addProduct(theData:InputData, editable:boolean ) {

              this.productList = [];
              this.productList.push( new ProductEdit(false,4,'product.BR','') );

              let orderOfBC:OrderOfBC = theData.orderOfBC;

              let type:number = 4;
              if ( editable ) type = 0;

              if ( theData.eligibility.isCustodyOtherThanParent != Confirm.YES ||
                   theData.aboutChild.isChildDeceased != Confirm.YES ) {

                   if ( orderOfBC.total == 0 ) {
                         this.productList.push( new ProductEdit(true,type,'product.BCWithParent','') );
                   }
                   else {

                         this.orderTotal += orderOfBC.total;

                         if ( orderOfBC.amountForBCWithParent > 0 ) {
                               this.productList.push( new ProductEdit(false,type,'product.BCWithParent',this.getPrice(orderOfBC.amountForBCWithParent)) );
                         }
                         if ( orderOfBC.amountForBC > 0 ) {
                               this.productList.push( new ProductEdit(false,type,'product.BCShort',this.getPrice(orderOfBC.amountForBC)) );
                         }
                         if ( orderOfBC.amountForCertifiedCopy > 0 ) {
                               this.productList.push( new ProductEdit(false,type,'product.CertifiedCopy',this.getPrice(orderOfBC.amountForCertifiedCopy)) );
                         }
                   }
              }

              if ( theData.eligibility.isCustodyOtherThanParent != Confirm.YES ) {

                   if ( editable ) type = 1;
                   if ( theData.CCB.chk_consent == true ) {
                        this.productList.push( new ProductEdit(false,type,'product.CCB','') );     
                   }
                   else this.productList.push( new ProductEdit(true,type,'product.CCB','') );     
              }


              if ( theData.eligibility.isCustodyOtherThanParent != Confirm.YES &&
                   theData.aboutChild.isChildDeceased != Confirm.YES ) {
 
                   if ( editable ) type = 2;
                   if ( theData.SIN.chk_read == true ) {
                         this.productList.push( new ProductEdit(false,type,'product.SIN','') );     
                   }
                   else  this.productList.push( new ProductEdit(true,type,'product.SIN','') );     

                   if ( editable ) type = 3;
                   if ( theData.CESP.chk_consent == true ) {
                        this.productList.push( new ProductEdit(false,type,'product.ESR','') );     
                   }
                   else this.productList.push( new ProductEdit(true,type,'product.ESR','') );     
              }

              let childProduct:ChildProduct = new ChildProduct();
                  childProduct.childName = theData.aboutChild.name.getFullName();
                  childProduct.products = this.productList;

              this.childList.push(childProduct);
      }


      private target:number = 0;
      public onEdit(index) {

             let type = this.productList[index].type;
/**
             switch(type) {
                   case 0: this.url = Path.BirthCertificate; ; break; // this.backCnt -= this.data.pageIndex.orderBC; break;
                   case 1: this.url = Path.CCBMain; ; break; // this.backCnt -= this.data.pageIndex.CCB; break;
                   case 2: this.url = Path.SINMain; ; break; // this.backCnt -= this.data.pageIndex.SIN; break;
                   case 3: this.url = Path.ESRMain; ; break; // this.backCnt -= this.data.pageIndex.CESP; break;
                   default: return;
             }
 */

             switch(type) {
                  case 0:  this.backCnt = 5; this.target = 18; break;
                  case 1:  this.backCnt = 3; this.target = 20; break;
                  case 2:  this.backCnt = 2; this.target = 21; break;
                  case 3:  this.backCnt = 1; this.target = 22; break;
                  default: this.backCnt = 0;
             }
             

             if ( this.productList[index].isOptOut ) 
                  this.message = "order_summary.goback_add_msg";
             else this.message = "order_summary.goback_edit_msg";
             this.isOnEditOpened = true;
             this.alertBox.open();
      }

      public onConfirmNote() {
             this.isOnEditOpened = false;
             this.alertBox.close();
             ///this.router.navigate(["/"+this.url]);  

             if ( this.backCnt  == 0 ) return;

             this.timerService.isForwarding = true;
             InputData.moveNext = this.target;
 
             ///console.log("======>OS: target #",this.target, -this.backCnt);

             window.history.back();
      }

      public onNoteClose() {
             this.url = "";
             this.isOnEditOpened = false;
             this.alertBox.close();
      }

      public onSubmit() {

             if ( this.isLastPage ) {
                  if ( this.disabled == false )
                       this.submitApplication.submit();
             }
             else {
                   this.nextURL = Path.NextRegistration;
                   super.onNextClick();
             }
      }

      public resolved(captchaResponse: string) {
              
            this.data.subject.captcha = captchaResponse;
            this.disabled = false;
     }

     public keyPressEnter(event:any, index:any) {
            if ( event.keyCode == 13 ) {
                  this.onEdit(index);        
            }
      }

      @HostListener('document:keydown.escape', ['$event'])
       public escape(){
             if(this.isOnEditOpened) {
                  this.onNoteClose();
             }
      }

}

export class ChildProduct {
       public childName:string;
       public products:ProductEdit[] = [];
}

export class ProductEdit {
       constructor(public isOptOut:boolean, 
                   public type:number,
                   public prodName:string,
                   public price:string) {}
}